module.exports = __webpack_public_path__ + "static/media/uni-of-michigan-logo.93579d97.png";